import React from "react";
import SaudiRegionsAndCities from "../SaudiRegionsAndCities/SaudiRegionsAndCities";

export default function CompanyInput({ onInputChange, companyData }) {
  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    onInputChange(name, value);
  };

  // Handle location changes
  const handleLocationChange = (type, value) => {
    onInputChange(type, value);
  };

  return (
    <>
      <section className="row mb-5">
        <h4>
          {" "}
          <span>بيانات الشركة</span>
        </h4>
        <div className="col-12 mt-3 mb-2">
          <div>
            <label htmlFor="name">اسم الشركه</label>
            <input type="text" name="name" value={companyData?.name} placeholder="اسم الشركه" id="name" className="form-control" onChange={handleChange} />
          </div>
        </div>
        {/* <div className="col-md-6 mt-3">
          <div>
            <label htmlFor="managerName">اسم المدير</label>
            <input
              type="text"
              placeholder="اسم المدير"
              id="managerName"
              className="form-control"
              onChange={handleChange}
            />
          </div>
        </div> */}
      </section>

      <section className="row mb-5">
        <h4>
          {" "}
          <span> عنوان الشركة </span>
        </h4>
        <SaudiRegionsAndCities companyData={companyData} handleChange={onInputChange} onLocationChange={handleLocationChange} />
      </section>

      <section className="row mb-3">
        <h4>
          <span>بيانات التواصل</span>
        </h4>
        <div className="col-md-6 mb-2">
          <div>
            <label htmlFor="phone" className="mt-3">
              رقم الهاتف
            </label>
            <input type="text" name="phone" value={companyData?.phone} placeholder="رقم الهاتف" id="phone" className="form-control" onChange={handleChange} />
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <label htmlFor="email" className="mt-3">
              البريد الاليكتروني
            </label>
            <input type="email" name="email" value={companyData?.email} placeholder="البريد الاليكتروني" id="email" className="form-control" onChange={handleChange} />
          </div>
        </div>
      </section>
    </>
  );
}
